/**
 * Helper para manejar la navegación del aside
 */
class NavigationHelpers {
    /**
     * Mantiene abierta la sección activa del aside según la URL actual
     */
    static keepActiveSectionOpen() {
        // Incluir el query string: varias entradas comparten el mismo path y se
        // distinguen solo por el parámetro (ej. clientes ?profile=FRECUENTE). Al
        // comparar path+search, el link más específico (con query) gana cuando
        // corresponde, y el que no tiene query queda activo solo sin parámetros.
        const currentFull = window.location.pathname + window.location.search;

        // Primero, cerrar todos los collapse y remover estados activos
        this.closeAllCollapses();
        this.removeAllActiveStates();

        // Buscar el link que corresponde a la ruta actual
        const navLinks = document.querySelectorAll('.navbar-vertical .nav-link[href]');
        let activeLink = null;
        let bestMatch = 0;

        navLinks.forEach(link => {
            const href = link.getAttribute('href');

            // Ignorar enlaces que son solo hashes (toggles de collapse)
            if (!href || href.startsWith('#')) {
                return;
            }

            // Buscar la mejor coincidencia (el path más específico). Un href con
            // query exige coincidencia exacta; uno sin query matchea por prefijo.
            if (currentFull === href || currentFull.startsWith(href)) {
                const matchLength = href.length;
                if (matchLength > bestMatch) {
                    bestMatch = matchLength;
                    activeLink = link;
                }
            }
        });

        // Si encontramos un link activo
        if (activeLink !== null) {
            // Marcar el link como activo
            activeLink.classList.add('active');
            const parentLi = activeLink.closest('.nav-item');
            if (parentLi) {
                parentLi.classList.add('active');
            }

            // Abrir el collapse padre si existe
            const parentCollapse = activeLink.closest('.collapse');
            if (parentCollapse) {
                parentCollapse.classList.add('show');

                // Actualizar el botón toggle correspondiente
                const collapseId = parentCollapse.id;
                const toggleButton = document.querySelector(`[data-bs-toggle="collapse"][href="#${collapseId}"]`);
                if (toggleButton) {
                    toggleButton.setAttribute('aria-expanded', 'true');
                    toggleButton.classList.remove('collapsed');
                }
            }
        }
    }

    /**
     * Cierra todos los collapse del navbar vertical
     */
    static closeAllCollapses() {
        const allCollapses = document.querySelectorAll('.navbar-vertical .collapse.show');
        allCollapses.forEach(collapse => {
            collapse.classList.remove('show');
        });

        // Resetear todos los toggles
        const allToggles = document.querySelectorAll('.navbar-vertical [data-bs-toggle="collapse"]');
        allToggles.forEach(toggle => {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.classList.add('collapsed');
        });
    }

    /**
     * Remueve todos los estados activos del navbar
     */
    static removeAllActiveStates() {
        const activeLinks = document.querySelectorAll('.navbar-vertical .nav-link.active');
        activeLinks.forEach(link => {
            link.classList.remove('active');
        });

        const activeItems = document.querySelectorAll('.navbar-vertical .nav-item.active');
        activeItems.forEach(item => {
            item.classList.remove('active');
        });
    }

    /**
     * Configura el tema del navbar
     */
    static setupNavbarTheme() {
        const navbarTopStyle = window.config?.config?.phoenixNavbarTopStyle;
        const navbarTop = document.querySelector('.navbar-top');
        if (navbarTop && navbarTopStyle === 'darker') {
            navbarTop.setAttribute('data-navbar-appearance', 'darker');
        }

        const navbarVerticalStyle = window.config?.config?.phoenixNavbarVerticalStyle;
        const navbarVertical = document.querySelector('.navbar-vertical');
        if (navbarVertical && navbarVerticalStyle === 'darker') {
            navbarVertical.setAttribute('data-navbar-appearance', 'darker');
        }
    }

    /**
     * Inicializa todos los helpers de navegación
     */
    static init() {
        this.setupNavbarTheme();
        this.keepActiveSectionOpen();
    }
}

export default NavigationHelpers;
